import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import { MATreeStructureAbschluss } from '../default-content/abschluss-seite/MATreeStructureAbschluss';
import { TreeStructureAnlagenMA } from '../default-content/anlagen/TreestructureAnlagenMA';
import { TreeStructureErklaerungMA } from '../default-content/erklaerung/TreestructureErklaerungMA';
import { getFormStrucStammdatenblattMA } from '../default-content/stammdatenblatt/content/StammdatenblattMA';
import { TreeStructureWichtigeHinweiseMA } from '../default-content/wichtige-hinweise/TreeStructureWichtigeHinweiseMA';
import PersonalausgabenLoeweMA, {
	getPersonalausgabenLoeweMAChildren,
	getPersonalausgabenUebersichtLoeweMAChildren,
	PersonalausgabenUebersichtParentLoeweMA,
} from './content/PersonalausgabenLoeweMA';
import MittelabrufLoeweMA from './content/MittelabrufLoeweMA';
import ProjektDatenMALoewe from './content/ProjektdatenMALoewe';
import SachausgabenLoeweMA, {
	getSachausgabenLoeweMAChildren,
	getSachausgabenUebersichtLoeweMAChildren,
	SachausgabenUebersichtParentLoeweMA,
} from './content/SachausgabenLoeweMA';
import UebersichtBewilligungMALoewe, {
	getUebersichtBewilligungMALoeweChildren,
} from './content/UebersichtBewilligungMALoewe';

// Basic Structure, has to be adapted to Verbundpartner
export const TreeStructureMALoewe = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		...TreeStructureWichtigeHinweiseMA(application),
		{
			label: 'Projektdaten',
			content: <ProjektDatenMALoewe />,
			formStruc: getFormStrucStammdatenblattMA(application),
		},
		{
			label: 'Übersicht Bewilligung',
			content: <UebersichtBewilligungMALoewe parentOnly />,
			children: getUebersichtBewilligungMALoeweChildren(application),
		},
		...PersonalAusgabenStruktur(application),
		...SachAusgabenStruktur(application),
		{
			label: 'Mittelabruf',
			content: <MittelabrufLoeweMA />,
		},
		...TreeStructureAnlagenMA(application),
		...TreeStructureErklaerungMA(application),
		...MATreeStructureAbschluss(application),
	];

	return treeNodes;
};

const PersonalAusgabenStruktur = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Personalausgaben',
			content: <PersonalausgabenLoeweMA />,
			children: getPersonalausgabenLoeweMAChildren(_application),
		},
		{
			label: 'Personalausgaben Übersicht',
			content: <PersonalausgabenUebersichtParentLoeweMA />,
			children: getPersonalausgabenUebersichtLoeweMAChildren(_application),
		},
	];

	return treeNodes;
};
const SachAusgabenStruktur = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Sachausgaben',
			content: <SachausgabenLoeweMA />,
			children: getSachausgabenLoeweMAChildren(_application),
		},
		{
			label: 'Sachausgaben Übersicht',
			content: <SachausgabenUebersichtParentLoeweMA />,
			children: getSachausgabenUebersichtLoeweMAChildren(_application),
		},
	];

	return treeNodes;
};
